<wiz-hgroup #actionContainer width="100%" height="100%" verticalAlign="center" style="padding: 3px">
  <wiz-icon #btnConf (click)="showConf()">settings</wiz-icon >
    <wiz-hgroup width="100%">
      <wiz-label [wizLabel]="fullLabel" class="listItemFont" width="100%"></wiz-label>
    </wiz-hgroup>
  
  <wiz-icon #iconRemove (click)="doDelete()">delete</wiz-icon>
</wiz-hgroup>
